import React from 'react';
import { CtaButton } from '../ui/CtaButton';
import { CustomVideoPlayer } from '../ui/CustomVideoPlayer';
const pills = ['📚 5 módulos + 2 bonos', '📄 +200 páginas', '🇲🇽 Contexto mexicano', '📲 PDF digital'];
export function Hero() {
  return <header className="w-full bg-gradient-to-b from-ink-950 via-ink-900 to-pitch" data-id="element-109" data-mp="cujkib9i9hzp">
      <div className="mx-auto flex max-w-5xl flex-col items-center px-5 pb-20 pt-4 text-center md:pb-28" style={{
      alignItems: "center",
      justifyContent: "flex-start"
    }} data-id="element-110" data-mp="hvqumgz4et9j">
        <span className="inline-block rounded-full bg-brand-gold/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-brand-gold ring-1 ring-brand-gold/30" data-id="element-111" data-mp="quklrrtomrfp">
          ⚽ Método Fútbol Digital
        </span>
        <h1 className="mt-8 font-display text-4xl font-black leading-[1.08] text-white sm:text-5xl md:text-6xl" data-id="element-112" data-mp="10kxg2bratyz1">
          Protege, acompaña y <span className="text-brand-orange" data-id="element-113" data-mp="1ajmkp2u6pmxc">potencia la carrera</span>{' '}
          futbolística de tu hijo
        </h1>
        
        <div className="mt-10 mb-2 w-full max-w-[260px]" data-id="element-114" data-mp="9o2pxlktsqn2">
          <CustomVideoPlayer videoId="PxHo79LcHJM" data-id="element-115" data-mp="9lg9sxjvd2t8" />
        </div>
        <p className="mt-10 max-w-2xl text-base leading-relaxed text-body md:text-lg" style={{
        fontSize: "20px"
      }} data-id="element-116" data-mp="4n4ysjhu8m9f">
          <strong className="block font-bold text-white text-center" style={{
          fontSize: "20px"
        }} data-id="element-117" data-mp="3vwu8g5m3usgn">MÉTODO PARA PADRES DE FUTBOLISTAS</strong>
          El método listo para aplicar para padres y madres en México que quieren gestionar la
          carrera de su hijo con información, evitar estafas, contratos abusivos y oportunidades
          perdidas.
        </p>
        <ul className="mt-8 flex flex-wrap items-center justify-center gap-3" data-id="element-118" data-mp="imo83fmdy3nb">
          {pills.map(pill => <li key={pill} className="rounded-full border border-ink-border bg-ink-card/70 px-4 py-2 text-sm font-semibold text-body" data-id="element-119" data-mp="emnhkwm0i1zw">
              {pill}
            </li>)}
        </ul>
        <div className="mt-10" data-id="element-120" data-mp="16cii7pfble3v">
          <CtaButton size="xl" data-id="element-121" data-mp="16c8obqr5mmsw">Quiero el método ahora</CtaButton>
        </div>
        <p className="mt-5 text-sm text-subtle" data-id="element-122" data-mp="30mp9zn0j2co1">
          🔒 Pago seguro · ⚡ Acceso inmediato · ✅ Garantía de 7 días
        </p>
        <p className="mt-3 max-w-xl text-xs leading-relaxed text-subtle" data-id="element-123" data-mp="2qw42fa2vlxsz">
          Material educativo. No reemplaza la asesoría de un abogado especializado en derecho
          deportivo.
        </p>
      </div>
    </header>;
}